import type { Currency } from '@skin-seoul/service';
import type React from 'react';

export type ProductCardProps = {
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  name: string;
  brand: string;
  productImage: string;
  sku: string;
  currency: Currency;
  rating?: number;
  ranking?: number;
  reviewCount?: number;
  originalPrice: number;
  orientation?: 'vertical' | 'horizontal';
  salePrice?: number;
  theme?: 'light' | 'dark';
  children?: React.ReactNode;
};

// Campaign section types
export type CampaignProduct = {
  productId: string;
  name: string;
  brand: string;
  productImageUrls: string[];
  sku: string;
  currency: Currency;
  originalPrice: number;
  salePrice?: number;
  productLink: string;
};

export type ReviewStats = {
  averageRate: number;
  totalReviews: number;
};

export type CompetitorProduct = {
  price: {
    salesPrice: string | number;
  };
};

export type CampaignSectionTheme = 'light' | 'dark';
